import { Injectable } from "@angular/core";
import { CfsMenuItemModel } from "clearline-api";
import { BehaviorSubject } from "rxjs";
import { CarouselUserActionData, CarouselUserActionFeatureConfig } from "../models";

const defaultConfig: CarouselUserActionFeatureConfig = {
  canTextInput: false,
  canScan: false,
  useCustomScanner: false
};

@Injectable()
export class FeaturesService {
  private configSrc = new BehaviorSubject<CarouselUserActionFeatureConfig>(defaultConfig);

  readonly config$ = this.configSrc.asObservable();

  buildCarouselUserActionData(item: CfsMenuItemModel): CarouselUserActionData {
    const { locationId, cashRegisterId, widgetType, widgetId } = item.data;
    const featureConfig: CarouselUserActionFeatureConfig = this.extractFeaturesFromArray(item.features);

    return {
      action: item.action,
      locationId,
      cashRegisterId,
      widgetType,
      widgetId,
      featureConfig
    };
  }

  /**
   * Parse features from query params. Ex: ..&features=textInput,scan
   * @param featuresQueryParam
   */
  private extractFeaturesFromArray(features: string[] = []): CarouselUserActionFeatureConfig {
    const normalizedFeatures = features.map((f) => f.toLowerCase());

    return {
      canTextInput: normalizedFeatures.includes("textinput"),
      canScan: normalizedFeatures.includes("scan"),
      useCustomScanner: normalizedFeatures.includes("customscanner")
    };
  }
}
